// appels/detail services
// Pure async functions only: no React, no hooks, no state. Parse at this boundary.
import { privateApi } from "@core/libs/axios";
import { parseWith } from "@core/parse";
import { AppelSchema, type Appel } from "../../_shared/types";

/**
 * `GET /appels/{id}/`: the appel with its step states, the six texts, the read-only cohort facts and
 * the derived values. An appel that does not exist and one outside this account's scope both answer
 * `404 appel_not_found`, so the screen shows the same not-found state for both.
 */
export async function getAppel(id: string): Promise<Appel> {
  const path = `/appels/${id}/`;
  const dto = await privateApi.get<unknown>(path).then((r) => r.data);
  return parseWith(AppelSchema, dto, `GET ${path}`);
}
